import { render, staticRenderFns } from "./SinglePost.vue?vue&type=template&id=68838538&scoped=true&"
import script from "./SinglePost.vue?vue&type=script&lang=js&"
export * from "./SinglePost.vue?vue&type=script&lang=js&"
import style0 from "./SinglePost.vue?vue&type=style&index=0&id=68838538&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68838538",
  null
  
)

export default component.exports